export enum AnimalCommentsBulkActions {
  UpdateExisting = 'Update Most Recent',
  CreateNew = 'Create New',
}
